document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("hamburger").addEventListener("click", function () {
    document.getElementById("hamburger").classList.toggle("open");
    document.getElementById("slide").classList.toggle("show");
    document.querySelector(".header").classList.toggle("open");
  });
});



window.addEventListener("load", function () {
  document.getElementById("loading").classList.add("hide");
});


const top = document.getElementById("top");
const company = document.getElementById("company");
const workList = document.getElementById("workList");
const work = document.getElementById("work");
const contact = document.getElementById("contact");
const newsList = document.getElementById("newsList");
const news = document.getElementById("news");
const insurance = document.getElementById("insurance");
const recruit = document.getElementById("recruit");
const privacy = document.getElementById("privacy");
const header = document.querySelector("header");

if (top || insurance || recruit || newsList || workList) {
  header.querySelector(".header__outer").classList.add("white");
  header.querySelector(".header__nav").classList.add("white");
}

if (top) {
  const top_swiper = new Swiper("#topFvSlide", {
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    speed: 3000,
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  const topWorkBar = new SimpleBar(document.querySelector(".topWork__scroll"), {
    autoHide: false,
    direction: "rtl",
  });

  if (window.innerWidth <= 768) {
    const fixation_swiper = new Swiper("#topFixationSpSlide", {
      loop: true,
      spaceBetween: 40,
      slidePerView: 1,
      effect: "fade",
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 2000,
      pagination: {
        el: ".topFixation__pagination",
        clickable: true,
      },
    });
  }
}

if (company) {
  const company_swiper = new Swiper("#companySlide", {
    loop: true,
    speed: 1500,
    effect: "fade",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}

if (workList) {
  const workMore = document.getElementById("workMore");
  workMore.addEventListener("click", () => {
    workMore.parentElement.classList.add("hide");
    document.querySelectorAll(".workListTrack__item").forEach((e) => {
      e.classList.remove("hide");
    });
  });
}

if (work) {
  const work_before = new Swiper("#workBeforeSlide", {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 2000,
    effect: "fade",
    navigation: {
      nextEl: ".workBefore__slide-button--next",
      prevEl: ".workBefore__slide-button--prev",
    },
  });

  const work_after = new Swiper("#workAfterSlide", {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 2000,
    effect: "fade",
    navigation: {
      nextEl: ".workAfter__slide-button--next",
      prevEl: ".workAfter__slide-button--prev",
    },
  });
}

if (newsList) {
  const newsMore = document.getElementById("newsMore");
  newsMore.addEventListener("click", () => {
    newsMore.parentElement.classList.add("hide");
    document.querySelectorAll(".newsListTrack__item").forEach((e) => {
      e.classList.remove("hide");
    });
  });
}

if (insurance) {
  const insurance_swiper = new Swiper("#insuranceFvSlide", {
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    speed: 3000,
    effect: "fade",
  });
}